import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles';
import Card, {CardContent, CardMedia} from 'material-ui/Card';
import IconButton from 'material-ui/IconButton';
import Typography from 'material-ui/Typography';
import SkipPreviousIcon from 'material-ui-icons/SkipPrevious';
import PlayArrowIcon from 'material-ui-icons/PlayArrow';
import SkipNextIcon from 'material-ui-icons/SkipNext';
import firebase from 'firebase';
const styles = theme => ({
  card: {
    display: 'flex',
    background: 'none'
  },
  details: {
    width: 'calc(100vw - 80px)!important',
    display: 'flex',
    flexDirection: 'column',
    background: 'rgba(255, 255, 255, 0.2)!important'
  },
  content: {
    flex: '1 0 auto',
    paddingTop: '10px',
    marginLeft: '-40px'
  },
  cover: {
    width: '80px',
    height: '80px'
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing.unit,
    paddingBottom: theme.spacing.unit
  },
  playIcon: {
    height: 38,
    width: 38
  },
  songTitle: {
    color: '#fff'
  }
});

let playingNow = {};

function getFeesiePlaying() {
  let feesieId = sessionStorage.getItem("feesieId");
  var feesieSongs = firebase.database().ref('/feesies/' + feesieId + '/feesie_playing/');
  feesieSongs.on('value', function(snapshot) {
    let queueItemValue = snapshot.val();
    if (queueItemValue) {
      let songQueueItem = {
        s_id: queueItemValue.s_id,
        name: queueItemValue.name,
        artistName: queueItemValue.artistName,
        albumArtUrl: queueItemValue.albumArtUrl
      }
      playingNow = songQueueItem;
    }
  });
}

function currentSongCard(props) {
  getFeesiePlaying();
  const {classes, theme} = props;
    return (<div>
      <Card className={classes.card}>
        <CardMedia className={classes.cover} image={playingNow.albumArtUrl} title={playingNow.name + " album cover"}/>

        <div className={classes.details}>
          <CardContent className={classes.content}>
            <Typography className={classes.songTitle} type="headline">{playingNow.name}</Typography>
            <Typography className={classes.songTitle} type="subheading" color="secondary">
              {playingNow.artistName}
            </Typography>
          </CardContent>
          {
            theme.controls && <div className={classes.controls}>
                <IconButton aria-label="Previous">
                  {
                    theme.direction === 'rtl'
                      ? <SkipNextIcon/>
                      : <SkipPreviousIcon/>
                  }
                </IconButton>
                <IconButton aria-label="Play/pause">
                  <PlayArrowIcon className={classes.playIcon}/>
                </IconButton>
                <IconButton aria-label="Next">
                  {
                    theme.direction === 'rtl'
                      ? <SkipPreviousIcon/>
                      : <SkipNextIcon/>
                  }
                </IconButton>
              </div>
          }
        </div>
      </Card>
    </div>);
}

currentSongCard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, {
  withTheme: true,
  controls: false
})(currentSongCard);



// WEBPACK FOOTER //
// ./src/currentSongCard.js